import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'questionMarkIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 20,
  },
  height: {
    type: Number as PropType<number>,
    default: 21,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M10 0.961914C8.02219 0.961914 6.08879 1.5484 4.4443 2.64722C2.79981 3.74603 1.51809 5.30782 0.761209 7.13508C0.00433286 8.96234 -0.193701 10.973 0.192152 12.9128C0.578004 14.8526 1.53041 16.6345 2.92894 18.033C4.32746 19.4315 6.10929 20.3839 8.0491 20.7698C9.98891 21.1556 11.9996 20.9576 13.8268 20.2007C15.6541 19.4438 17.2159 18.1621 18.3147 16.5176C19.4135 14.8731 20 12.9397 20 10.9619C20 8.30975 18.9464 5.76621 17.0711 3.89085C15.1957 2.01548 12.6522 0.961914 10 0.961914ZM10 16.7952C9.75278 16.7952 9.5111 16.7219 9.30554 16.5846C9.09998 16.4472 8.93976 16.252 8.84515 16.0236C8.75055 15.7952 8.72579 15.5439 8.77402 15.3014C8.82225 15.0589 8.94131 14.8362 9.11612 14.6614C9.29094 14.4865 9.51367 14.3675 9.75614 14.3193C9.99862 14.271 10.25 14.2958 10.4784 14.3904C10.7068 14.485 10.902 14.6452 11.0393 14.8508C11.1767 15.0563 11.25 15.298 11.25 15.5452C11.25 15.8768 11.1183 16.1947 10.8839 16.4291C10.6495 16.6636 10.3315 16.7952 10 16.7952ZM11.3333 11.7286C11.1843 11.7936 11.0575 11.9009 10.9687 12.0371C10.8798 12.1734 10.8328 12.3326 10.8333 12.4952C10.8333 12.7163 10.7455 12.9282 10.5893 13.0845C10.433 13.2408 10.221 13.3286 10 13.3286C9.77899 13.3286 9.56703 13.2408 9.41075 13.0845C9.25447 12.9282 9.16667 12.7163 9.16667 12.4952C9.1666 12.0087 9.30848 11.5328 9.57492 11.1257C9.84136 10.7187 10.2208 10.3982 10.6667 10.2036C10.9418 10.0835 11.1795 9.89129 11.3544 9.6473C11.5294 9.40331 11.6352 9.11659 11.6607 8.81744C11.6861 8.51828 11.6303 8.2178 11.4991 7.94775C11.3679 7.6777 11.1662 7.4481 10.9153 7.28322C10.6644 7.11833 10.3736 7.02429 10.0737 7.01102C9.77371 6.99775 9.47575 7.06575 9.21126 7.20784C8.94677 7.34992 8.72558 7.56081 8.57105 7.81822C8.41651 8.07564 8.33438 8.37001 8.33334 8.67025C8.33334 8.89126 8.24554 9.10322 8.08926 9.2595C7.93298 9.41578 7.72102 9.50358 7.5 9.50358C7.27899 9.50358 7.06703 9.41578 6.91075 9.2595C6.75447 9.10322 6.66667 8.89126 6.66667 8.67025C6.66726 8.06942 6.83024 7.47992 7.13836 6.96412C7.44648 6.44831 7.88828 6.02538 8.41704 5.74005C8.94579 5.45472 9.54183 5.31761 10.1421 5.34323C10.7424 5.36884 11.3246 5.55623 11.8271 5.88556C12.3296 6.2149 12.7338 6.67393 12.9969 7.21411C13.2599 7.75429 13.3721 8.35553 13.3215 8.95422C13.2709 9.55292 13.0594 10.1268 12.7095 10.6152C12.3595 11.1035 11.884 11.4882 11.3333 11.7286Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})